var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#EBECED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 27.5C19.6833 27.5 18.146 26.8707 16.888 25.612C15.63 24.3533 15.0007 22.816 15 21C14.9993 19.184 15.6287 17.6467 16.888 16.388C18.1473 15.1293 19.6847 14.5 21.5 14.5C23.3153 14.5 24.853 15.1293 26.113 16.388C27.373 17.6467 28.002 19.184 28 21C28 21.7333 27.8833 22.425 27.65 23.075C27.4167 23.725 27.1 24.3 26.7 24.8L32.3 30.4C32.4833 30.5833 32.575 30.8167 32.575 31.1C32.575 31.3833 32.4833 31.6167 32.3 31.8C32.1167 31.9833 31.8833 32.075 31.6 32.075C31.3167 32.075 31.0833 31.9833 30.9 31.8L25.3 26.2C24.8 26.6 24.225 26.9167 23.575 27.15C22.925 27.3833 22.2333 27.5 21.5 27.5ZM21.5 25.5C22.75 25.5 23.8127 25.0627 24.688 24.188C25.5633 23.3133 26.0007 22.2507 26 21C25.9993 19.7493 25.562 18.687 24.688 17.813C23.814 16.939 22.7513 16.5013 21.5 16.5C20.2487 16.4987 19.1863 16.9363 18.313 17.813C17.4397 18.6897 17.002 19.752 17 21C16.998 22.248 17.4357 23.3107 18.313 24.188C19.1903 25.0653 20.2527 25.5027 21.5 25.5Z",
    fill: "#354147"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.a2f8e47560cc4571f98056b55707115b.svg";
export { ForwardRef as ReactComponent };